<svelte:options immutable={true} />

<script lang="ts">
  import { onMount, createEventDispatcher } from "svelte";
  import { pannable } from "./utils/pannable.js";
  import { goTo, shellUrl } from "./utils/productHost";
  export let display;
  export let user_data;
  const dispatch = createEventDispatcher();
  const currentYear = new Date().getFullYear();
  async function render() {}
  onMount(render);
  function onHide() {
    dispatch("hide");
  }
  function onReload() {
    location.reload();
  }
  function gotoPage(link: string) {
    try {
      const cleanLink = link.endsWith("/") ? link.slice(0, -1) : link;
      let url = shellUrl(cleanLink === "" ? "home" : cleanLink);
      const token = localStorage.getItem("token");
      if (token && cleanLink !== "" && cleanLink !== "/") {
        const sep = url.includes("?") ? "&" : "?";
        url = `${url}${sep}rtnk=${encodeURIComponent(token)}`;
      }
      goTo(url);
    } catch (e) {
      goTo(link === "" ? "https://legalpal.app/" : `https://legalpal.app/${link}`);
    }
  }
</script>

<button class="main-sidebar__open" on:click={onHide}>
  <svg
    class="main-sidebar__open-icon"
    xmlns="http://www.w3.org/2000/svg"
    version="1.1"
    xmlns:xlink="http://www.w3.org/1999/xlink"
    x="0"
    y="0"
    viewBox="0 0 6.35 6.35"
    style="enable-background:new 0 0 512 512"
    xml:space="preserve"
    ><g
      ><path
        d="M2.258 1.315a.265.265 0 0 0-.174.469L3.703 3.17l-1.62 1.386a.265.265 0 1 0 .345.4L4.28 3.373a.265.265 0 0 0 0-.403L2.428 1.382a.265.265 0 0 0-.17-.067z"
        fill="#000000"
        data-original="#000000"
        class=""
      /></g
    ></svg
  >
</button>
<div
  class="left-menu-wrap fixed left-0 top-0 select-none"
  class:pending={!display}
  on:mouseleave={() => {
    // Only auto-close on desktop hover UX – touch devices don't need mouseleave
    if (typeof window !== 'undefined' && window.matchMedia('(min-width: 768px)').matches) {
      onHide();
    }
  }}
>
  <div class="w-full main-sidebar">
    <button class="main-sidebar__close" on:click={onHide} type="button" aria-label="Close sidebar">
      <svg
        xmlns="http://www.w3.org/2000/svg"
        version="1.1"
        xmlns:xlink="http://www.w3.org/1999/xlink"
        x="0"
        y="0"
        viewBox="0 0 329.269 329"
        style="enable-background:new 0 0 512 512"
        xml:space="preserve"
        ><g
          ><path
            d="M194.8 164.77 323.013 36.555c8.343-8.34 8.343-21.825 0-30.164-8.34-8.34-21.825-8.34-30.164 0L164.633 134.605 36.422 6.391c-8.344-8.34-21.824-8.34-30.164 0-8.344 8.34-8.344 21.824 0 30.164l128.21 128.215L6.259 292.984c-8.344 8.34-8.344 21.825 0 30.164a21.266 21.266 0 0 0 15.082 6.25c5.46 0 10.922-2.09 15.082-6.25l128.21-128.214 128.216 128.214a21.273 21.273 0 0 0 15.082 6.25c5.46 0 10.922-2.09 15.082-6.25 8.343-8.34 8.343-21.824 0-30.164zm0 0"
            fill="#000000"
            data-original="#000000"
            class=""
          ></path></g
        ></svg
      >
    </button>
    <div
      class="w-full flex items-center cursor-pointer logo"
      style="margin-bottom: 50px;"
      on:click={() => gotoPage("")}
    >
      <img alt="" class="qix-logo" src="/img/logo.svg" />
    </div>
    <a
      class="w-full flex items-center item cursor-pointer"
      on:click|preventDefault={() => gotoPage("sign")}
      href="https://legalpal.app/sign"
    >
      <img src="/img/signAsset.svg" alt="" />Sign
    </a>
    <a
      class="w-full flex items-center item cursor-pointer"
      on:click|preventDefault={() => gotoPage("chat")}
      href="https://legalpal.app/chat"
    >
      <img src="/img/chatAsset.svg" alt="" />Chat
    </a>
    <a
      class="w-full flex items-center item cursor-pointer"
      on:click|preventDefault={() => gotoPage("app")}
      href="https://legalpal.app/app"
    >
      <img src="/img/appAsset.svg" alt="" />App
    </a>
    <a
      class="w-full flex items-center item cursor-pointer"
      on:click|preventDefault={() => gotoPage("api")}
      href="https://legalpal.app/api"
    >
      <img src="/img/cloudAsset.svg" alt="" />Api
    </a>
    <div
      class="w-full flex items-center item cursor-pointer"
      on:click|preventDefault={() => gotoPage("account")}
    >
      <img alt="" src="account_icon.png" />Account
    </div>
    <div
      class="w-full flex items-center item cursor-pointer"
      on:click|preventDefault={() => gotoPage("help")}
    >
      <img alt="" src="help.png" />Help
    </div>
  </div>
  <div class="menu-footer">
    <a
      on:click|preventDefault={() => gotoPage("privacy-policy")}
      style="cursor: pointer;">Privacy Policy</a
    >
    <div>Copyright LegalPal Inc.<br />{currentYear}</div>
  </div>
</div>

<style>
  .main-sidebar {
    position: relative;
    padding-top: 20px;
  }

  .main-sidebar__close {
    position: absolute;
    right: 20px;
    top: 20px;
    width: 14px;
    height: auto;
    transition: opacity 0.25s;
    background-color: transparent;
    border: none;
    outline: none;
    padding: 0;
    box-shadow: none;
    cursor: pointer;
  }

  .main-sidebar__close:hover {
    opacity: 0.6;
  }
  .qix-logo {
    width: 65px;
  }

  .main-sidebar a {
    color: #000;
  }

  .main-sidebar__open {
    position: fixed;
    bottom: 20px;
    left: 0;
    background-color: #fff;
    width: 70px;
    height: 70px;
    box-shadow: 5px 0 10px gray;
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: flex-end;
    padding-right: 10px;
    transform: scale(1) translate(-50%);
    cursor: pointer;
    border: none;
    outline: none;
    transition:
      background-color 0.3s,
      opacity 0.4s,
      visibility 0.4s,
      transform 0.4s;
    transform-origin: 20% 50%;
  }
  @media (max-width: 768px) {
    .main-sidebar__open {
      bottom: 16px;
      left: 8px;
      width: 48px;
      height: 48px;
      z-index: 30;
      transform: none;
      justify-content: center;
      padding-right: 0;
    }
  }
  .main-sidebar__open:hover {
    background-color: #e8e8e8;
  }
  .main-sidebar__open-icon {
    width: 20px;
    height: auto;
    pointer-events: none;
  }
  .menu-footer {
    position: absolute;
    bottom: 20px;
    left: 0;
    text-align: center;
    width: 100%;
  }
  .menu-footer > a {
  }
  .menu-footer > div {
    margin-top: 10px;
    font-size: 12px;
  }
  .left-menu-wrap {
    height: 100vh;
    width: 200px;
    background: #fff;
    z-index: 99;
    box-shadow: 5px 0px 10px 0px grey;
    transition: 0.5s;
  }
  .left-menu-wrap.pending {
    left: -300px;
  }
  .logo {
    padding: 0 15px;
  }
  .item {
    padding: 15px;
  }
  .item:hover {
    background: #e8e8e8;
  }
  .item img {
    margin-right: 10px;
    width: 30px;
  }
</style>